import { useEffect, useMemo } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { Onboarding } from "@boundary/widgets/onboarding";
import { ONBOARDING_FLOW, OnboardingFlowSteps } from "@boundary/pages/4.onboarding/onboardingFlow";
import { prefetchAndNavigate } from "@boundary/utils/prefetchRoute";

const VALID_STEPS: OnboardingFlowSteps[] = ["map", "order", "pickup"];

export const ONBOARDING_IMAGES = [
  "/assets/onboarding/map-onboarding.png",
  "/assets/onboarding/service-onboarding.png"
];

export function preloadOnboardingImages() {
  ONBOARDING_IMAGES.forEach(src => {
    const img = new Image();
    img.src = src;
  });
}

export function OnboardingPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  const stepParam = searchParams.get("step") as OnboardingFlowSteps | null;
  // startingSlide должен обновляться при изменении stepParam
  const startingSlide = useMemo(() => {
    return stepParam && VALID_STEPS.includes(stepParam) ? stepParam : "map";
  }, [stepParam]);

  // Получаем returnTo из state или searchParams, по умолчанию /map
  const returnTo = (location.state as { returnTo?: string })?.returnTo || 
                   searchParams.get("returnTo") || 
                   "/map";

  useEffect(() => {
    preloadOnboardingImages();
  }, []);

  const handleComplete = () => {
    // Возвращаемся туда, откуда пришли (или на /map по умолчанию)
    // Не используем replace, чтобы можно было вернуться назад
    prefetchAndNavigate(navigate, returnTo);
  };

  return (
    <Onboarding
      slides={ONBOARDING_FLOW}
      onComplete={handleComplete}
      startingSlide={startingSlide}
    />
  );
}
